import React from "react";
import { Row, Col } from "antd";
import moment from "moment";
import * as etiquetas from "../../ApplicationResources";
import InputText from "../interfaz/InputText";
import Calendario from "../interfaz/Calendario";
import { estaFechaEnRango, fechaEsAnterior, fechaEsPosterior } from "../../utils/funciones";

class ExperienciaLaboralItem extends React.Component {
  constructor(props) {
    // Calling the constructor of
    // Parent Class React.Component
    super(props);

    // Setting the initial state
    this.state = {
      fechaInicioEmpresaMaxDate: moment().format(
        etiquetas.FORMATO_FECHA_MOMENT
      ),
      fechaFinEmpresaMinDate: moment("01/01/1900").format(
        etiquetas.FORMATO_FECHA_MOMENT
      ),
    };

    this.handleFechaInicioEmpresaChange =
      this.handleFechaInicioEmpresaChange.bind(this);
    this.handleFechaFinEmpresaChange =
      this.handleFechaFinEmpresaChange.bind(this);
  }

  handleFechaInicioEmpresaChange = (value) => {
    this.setState(
      {
        fechaFinEmpresaMinDate: value
          ? moment(value).format(etiquetas.FORMATO_FECHA_MOMENT)
          : moment("01/01/1900").format(etiquetas.FORMATO_FECHA_MOMENT),
      },
      () => {
        this.props.form.validateFields([this.props.fechaFinEmpresa], {
          force: true,
        });
      }
    );
    this.verificarFecha(this.props.fechaInicioEmpresa);
  };

  handleFechaFinEmpresaChange = (value) => {
    this.setState(
      {
        fechaInicioEmpresaMaxDate: value
          ? moment(value).format(etiquetas.FORMATO_FECHA_MOMENT)
          : moment().format(etiquetas.FORMATO_FECHA_MOMENT),
      },
      () => {
        this.props.form.validateFields([this.props.fechaInicioEmpresa], {
          force: true,
        });
      }
    );
    this.verificarFecha(this.props.fechaFinEmpresa);
  };

  /*
   * Valida que la fecha sea valida de acuerdo al número de puesto que se encuentre capturando.
   * Los empleos se capturarán del más reciente al más antiguo.
   */
  verificarFecha(nombreFecha) {
    /*
    fi1 = Fecha Inicial 1(fecha inicial del puesto más reciente)
    ff1 = Fecha Final 1(fecha final del puesto más reciente)
    fi3 = Fecha Inicial 3(fecha inicial del puesto más antiguo)
    ff3 = Fecha Final 3(fecha final del puesto más antiguo)
    */
    var fi1, fi2, fi3, ff1, ff2, ff3;
    var inputFi1, inputFi2, inputFi3, inputFf1, inputFf2, inputFf3;

    inputFi1 = this.props.form.getFieldValue("fechaInicioEmpresa1");
    inputFi2 = this.props.form.getFieldValue("fechaInicioEmpresa2");
    inputFi3 = this.props.form.getFieldValue("fechaInicioEmpresa3");

    inputFf1 = this.props.form.getFieldValue("fechaFinEmpresa1");
    inputFf2 = this.props.form.getFieldValue("fechaFinEmpresa2");
    inputFf3 = this.props.form.getFieldValue("fechaFinEmpresa3");

    fi1 = inputFi1 !== undefined ? new Date(inputFi1) : null;
    fi2 = inputFi2 !== undefined ? new Date(inputFi2) : null;
    fi3 = inputFi3 !== undefined ? new Date(inputFi3) : null;

    ff1 = inputFf1 !== undefined ? new Date(inputFf1) : null;
    ff2 = inputFf2 !== undefined ? new Date(inputFf2) : null;
    ff3 = inputFf3 !== undefined ? new Date(inputFf3) : null;

    switch (nombreFecha) {
      case "fechaInicioEmpresa1":
        if (estaFechaEnRango(fi2, ff2, fi1) || fechaEsAnterior(fi1, fi2) || fechaEsAnterior(fi1, ff2))
          this.props.callbackResponse({ 5: { fechaInicioEmpresa1: { error: etiquetas.datos_experiencia_laboral_msj_fecha_posterior.replace("<num>", "2") } } });
        if (estaFechaEnRango(fi3, ff3, fi1) || fechaEsAnterior(fi1, fi3) || fechaEsAnterior(fi1, ff3))
          this.props.callbackResponse({ 5: { fechaInicioEmpresa1: { error: etiquetas.datos_experiencia_laboral_msj_fecha_posterior.replace("<num>", "3") } } });
        break;
      case "fechaInicioEmpresa2":
        if (estaFechaEnRango(fi1, ff1, fi2) || fechaEsPosterior(fi2, fi1) || fechaEsPosterior(fi2, ff1))
          this.props.callbackResponse({ 5: { fechaInicioEmpresa2: { error: etiquetas.datos_experiencia_laboral_msj_fecha_anterior.replace("<num>", "1") } } });
        if (estaFechaEnRango(fi3, ff3, fi2) || fechaEsAnterior(fi2, fi3) || fechaEsAnterior(fi2, ff3))
          this.props.callbackResponse({ 5: { fechaInicioEmpresa2: { error: etiquetas.datos_experiencia_laboral_msj_fecha_posterior.replace("<num>", "3") } } });
        break;
      case "fechaInicioEmpresa3":
        if (estaFechaEnRango(fi1, ff1, fi3) || fechaEsPosterior(fi3, fi1) || fechaEsPosterior(fi3, ff1))
          this.props.callbackResponse({ 5: { fechaInicioEmpresa3: { error: etiquetas.datos_experiencia_laboral_msj_fecha_anterior.replace("<num>", "1") } } });
        if (estaFechaEnRango(fi2, ff2, fi3) || fechaEsPosterior(fi3, fi2) || fechaEsPosterior(fi3, ff2))
          this.props.callbackResponse({ 5: { fechaInicioEmpresa3: { error: etiquetas.datos_experiencia_laboral_msj_fecha_anterior.replace("<num>", "2") } } });
        break;
      case "fechaFinEmpresa1":
        if (estaFechaEnRango(fi2, ff2, ff1) || fechaEsAnterior(fi1, fi2) || fechaEsAnterior(fi1, ff2))
          this.props.callbackResponse({ 5: { fechaFinEmpresa1: { error: etiquetas.datos_experiencia_laboral_msj_fecha_posterior.replace("<num>", "2") } } });
        if (estaFechaEnRango(fi3, ff3, ff1) || fechaEsAnterior(fi1, fi3) || fechaEsAnterior(fi1, ff3))
          this.props.callbackResponse({ 5: { fechaFinEmpresa1: { error: etiquetas.datos_experiencia_laboral_msj_fecha_posterior.replace("<num>", "3") } } });
        break;
      case "fechaFinEmpresa2":
        if (estaFechaEnRango(fi1, ff1, ff2) || fechaEsPosterior(ff2, fi1) || fechaEsPosterior(ff2, ff1))
          this.props.callbackResponse({ 5: { fechaFinEmpresa2: { error: etiquetas.datos_experiencia_laboral_msj_fecha_anterior.replace("<num>", "1") } } });
        if (estaFechaEnRango(fi3, ff3, ff2) || fechaEsAnterior(ff2, fi3) || fechaEsAnterior(ff2, ff3))
          this.props.callbackResponse({ 5: { fechaFinEmpresa2: { error: etiquetas.datos_experiencia_laboral_msj_fecha_posterior.replace("<num>", "3") } } });
        break;
      case "fechaFinEmpresa3":
        if (estaFechaEnRango(fi1, ff1, ff3) || fechaEsPosterior(ff3, fi1) || fechaEsPosterior(ff3, ff1))
          this.props.callbackResponse({ 5: { fechaFinEmpresa3: { error: etiquetas.datos_experiencia_laboral_msj_fecha_anterior.replace("<num>", "1") } } });
        if (estaFechaEnRango(fi2, ff2, ff3) || fechaEsPosterior(ff3, fi2) || fechaEsPosterior(ff3, ff2))
          this.props.callbackResponse({ 5: { fechaFinEmpresa3: { error: etiquetas.datos_experiencia_laboral_msj_fecha_anterior.replace("<num>", "2") } } });
        break;
      default:
        break;
    }
  }

  render() {
    return (
      <React.Fragment>
        <Row gutter={8}>
          <Col sm={24} md={12} lg={12}>
            <InputText
              nombre={this.props.nombreEmpresa}
              placeholder={
                etiquetas.datos_experiencia_laboral_lbl_nombreEmpresa
              }
              form={this.props.form}
              required={false}
              msjRequerido={etiquetas.general_dato_requerido}
              maxLength={40}
              rules={[
                {
                  max: 40,
                  pattern: etiquetas.REGEX_FORMATO_NO_CARACTERES_ESPECIALES,
                },
              ]}
            />
          </Col>
          <Col sm={24} md={12} lg={12}>
            <InputText
              nombre={this.props.puestoEmpresa}
              placeholder={
                etiquetas.datos_experiencia_laboral_lbl_puestoEmpresa
              }
              form={this.props.form}
              required={this.props.form.getFieldValue(this.props.nombreEmpresa)}
              msjRequerido={etiquetas.general_dato_requerido}
              maxLength={40}
              rules={[
                {
                  max: 40,
                  pattern: etiquetas.REGEX_FORMATO_NO_CARACTERES_ESPECIALES,
                },
              ]}
            />
          </Col>
        </Row>
        <Row gutter={8}>
          <Col sm={24} md={12} lg={12}>
            <Calendario
              nombre={this.props.fechaInicioEmpresa}
              placeholder={
                etiquetas.datos_experiencia_laboral_lbl_fechaInicioEmpresa
              }
              label={etiquetas.datos_experiencia_laboral_lbl_fechaInicioEmpresa}
              form={this.props.form}
              required={false}
              msjRequerido={etiquetas.general_dato_requerido}
              format={etiquetas.FORMATO_FECHA_MOMENT}
              formato="dd/mm/aaaa"
              showTime={false}
              showToday={true}
              minDate="01/01/1900"
              maxDate={this.state.fechaInicioEmpresaMaxDate}
              onChange={(value) => this.handleFechaInicioEmpresaChange(value)}
            />
          </Col>
          <Col sm={24} md={12} lg={12}>
            <Calendario
              nombre={this.props.fechaFinEmpresa}
              placeholder={
                etiquetas.datos_experiencia_laboral_lbl_fechaFinEmpresa
              }
              label={etiquetas.datos_experiencia_laboral_lbl_fechaFinEmpresa}
              form={this.props.form}
              required={false}
              msjRequerido={etiquetas.general_dato_requerido}
              format={etiquetas.FORMATO_FECHA_MOMENT}
              formato="dd/mm/aaaa"
              showTime={false}
              showToday={true}
              minDate={this.state.fechaFinEmpresaMinDate}
              maxDate={moment().format(etiquetas.FORMATO_FECHA_MOMENT)}
              onChange={(value) => this.handleFechaFinEmpresaChange(value)}
            />
          </Col>
          <Col sm={24} md={12} lg={12}>
            <InputText
              nombre={this.props.telefonoEmpresa}
              placeholder={
                etiquetas.datos_experiencia_laboral_lbl_telefonoEmpresa
              }
              realPlaceholder="(999)9999999"
              form={this.props.form}
              required={false}
              msjRequerido={etiquetas.general_dato_requerido}
              maxLength={10}
              rules={[
                {
                  min:8,
                  max: 10,
                  pattern: etiquetas.REGEX_FORMATO_TELEFONO,
                },
              ]}
              custom={{
                getValueFromEvent: (event, previo) => {
                    if(etiquetas.REGEX_FORMATO_SOLO_DIGITOS.test(event.target.value)){
                        return	event.target.value;
                    }
                    return previo;
                }
            }}
            />
          </Col>
        </Row>
      </React.Fragment>
    );
  }
}

export default ExperienciaLaboralItem;
